import { TabType } from '@app/config-builder/common';
import { ApiAppParams } from '@typings/apiApp';
import { atom, createStore } from 'jotai';
import { defaultTranslations } from '@/modules/common';

type MakeOptional<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;

export type PromptTranslation = {
  id: number;
  caption: string;
};

export type ConfigType = MakeOptional<
  Omit<ApiAppParams, 'translations'>,
  'apiUrl' | 'apiKey' | 'closeChatWithEsc' | 'projectName'
> & {
  version?: string;
  translations?: Partial<typeof defaultTranslations> & {
    prompts?: PromptTranslation[];
  };
  relatedTenants?: Record<
    string,
    {
      devKey: string;
      prodKey: string;
    }
  >;
};

export type DemoConversation = {
  id?: number;
  name: string;
  description?: string;
  tenant: string;
  apiKey: string;
  chatId: number;
  token: string;
};

export const store = createStore();

export const tenantsListAtom = atom<{
  [key: string]: {
    dev: string;
    prod: string;
  };
}>({});

export const configAtom = atom<ConfigType | null>(null);
export const backupConfigAtom = atom<ConfigType | null>(null);
export const lastFetchedConfigAtom = atom<ConfigType | null>(null);
export const currentTenantAtom = atom<string | null>(null);
export const demoConversationTenantAtom = atom<string | null>(null);
export const currentMLEnvAtom = atom<'dev' | 'prod'>();
export const activeTabAtom = atom<TabType>(TabType.COLORS);
export const currentLanguageAtom = atom<keyof typeof defaultTranslations>('en');
